import useInteractiveWidgetSubmit from '../../hooks/useInteractiveWidgetSubmit';
import useArtAvailability from '../../hooks/useArtAvailability';
import {PostQuantitySelector} from '../../../../shared/campaign/PostQuantitySelector';
import {
  buildPostQuantityCompletionMessage,
  CAMPAIGN_WIDGET_TOOL_NAMES,
} from '../../utils/campaignCompletionMessages';
import {postQuantityWidget} from '../../domain/campaignToolCatalog';

export default function PostQuantityIntegration({
  selectedValue = null,
  availableArts: availableArtsProp = null,
  isReadOnly = false,
  toolCallId = null,
}) {
  const {availableArts: fetchedAvailableArts} = useArtAvailability({
    enabled: availableArtsProp == null && !isReadOnly,
  });
  const availableArts = availableArtsProp ?? fetchedAvailableArts;

  const {handleSubmit: handleComplete, isPending} = useInteractiveWidgetSubmit(
    CAMPAIGN_WIDGET_TOOL_NAMES.QUANTIDADE_ARTES,
    toolCallId,
    (data) => buildPostQuantityCompletionMessage(data.quantity),
  );

  return (
    <PostQuantitySelector
      selectedValue={selectedValue}
      availableArts={availableArts}
      isReadOnly={isReadOnly || isPending}
      onFinalize={(quantity) => {
        if (isReadOnly || isPending) return;
        handleComplete({quantity});
      }}
    />
  );
}

export {postQuantityWidget};
